export function formatInvoices(n:number,f:number){
    let val:any = Math.abs(n);
    if (val >= 10000000) {
      val = `${(val / 10000000).toFixed(f)}Cr`;
    } else if (val >= 100000) {
      val = `${(val / 100000).toFixed(f)}L`;
    } else if (val>=1000){
      val = `${(val / 1000).toFixed(f)}K`;
    }
    return val;
}

export function formatMISCardDetails(n:number) {
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}